import { Outlet } from "react-router-dom";
import Header from "../../../layouts/Header/Header";
import Footer from "../../../layouts/Footer/Footer";
import ScrollToTop from "../../ScrollToTopOnPageChange";
import React, { useEffect, useState } from "react";
import PromoPopup, {
  CampaignDisplay,
} from "../../pages/home/promo-popup/PromoPopup";
import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import LiveSupportComponent from "../../live-support/LiveSupportComponent";

const PROMO_STORAGE_KEY = "bsc-promo-seen-v1";

interface ITranslation {
  id: number;
  popup_id: number;
  locale: string;
  text: string;
  image: string;
}

interface IPopupItem {
  id: number;
  active: boolean;
  translations: ITranslation[];
  created_at: string;
  updated_at: string;
}

const MainRoot = (): JSX.Element => {
  const [isPromoOpen, setIsPromoOpen] = useState(false); // Başlanğıcda false edirik, data gələndə açarıq
  const [campaign, setCampaign] = useState<CampaignDisplay | null>(null);
  const [isLoadingCampaign, setIsLoadingCampaign] = useState(true);

  // 1. Datanı gətirmək
  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        setIsLoadingCampaign(true);
        const response = await $axios.get($api("popup"));

        const list: IPopupItem[] = response.data.data || [];

        if (Array.isArray(list) && list.length > 0) {
          // Aktiv olanları tapırıq
          const activePopups = list.filter((item) => item.active === true);

          if (activePopups.length > 0) {
            // Sonuncu aktiv popup-ı götürürük
            const targetPopup = activePopups[activePopups.length - 1];

            // --- DƏYİŞİKLİK EDİLƏN HİSSƏ ---
            // Dilə görə axtarışı sildim.
            // Birbaşa array-in 1-ci elementini (index 0) götürürük.
            const translation =
              targetPopup.translations.length > 0
                ? targetPopup.translations[0]
                : null;
            // -------------------------------

            if (translation) {
              setCampaign({
                id: targetPopup.id,
                text: translation.text,
                cover_image: translation.image,
              });
            } else {
              setCampaign(null);
            }
          } else {
            setCampaign(null);
          }
        } else {
          setCampaign(null);
        }
      } catch (error) {
        console.error("Popup fetch error:", error);
        setCampaign(null);
      } finally {
        setIsLoadingCampaign(false);
      }
    };

    fetchCampaign();
  }, []);

  // 2. Popup-ı açmaq
  useEffect(() => {
    const seen = localStorage.getItem(PROMO_STORAGE_KEY);

    // Kampaniya doludursa və "seen" yoxdursa
    if (!seen && campaign) {
      const timer = setTimeout(() => {
        setIsPromoOpen(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [campaign]);

  const handleClosePromo = () => {
    setIsPromoOpen(false);
    localStorage.setItem(PROMO_STORAGE_KEY, "true");
  };

  return (
    <>
      <ScrollToTop />

      <PromoPopup
        isOpen={isPromoOpen}
        onClose={handleClosePromo}
        campaign={campaign}
        isLoading={isLoadingCampaign}
      />

      <Header />
      <main style={{ minHeight: "80vh" }}>
        <Outlet />
      </main>
      <Footer />
      <LiveSupportComponent />
    </>
  );
};

export default MainRoot;
